import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { useParams, Link } from 'react-router-dom'
import Spinner from '../spinner'
import { inheritPrimaryColor } from '../colors'
import getContentProps from '../get-content-props'
import root from '../root-path'
import { useScrollReset } from '../scroll'

const jsonRoot = `${root}/wp-json/wp/v2`

const getArticle = async slug => {
  const response = await fetch(`${jsonRoot}/articles?slug=${slug}`)
  return response.json()
}

const useArticle = (getInitialState, slug) => {
  const [article, setArticle] = useState(getInitialState)
  useEffect(() => {
    if (!article) {
      (async () => {
        const article = await getArticle(slug)
        setArticle(article[0])
      })()
    }
  }, [])
  return article
}
const StyledLink = styled(Link)`
  text-decoration: none; display: inline-flex; align-items: center;
`
const ReturnToAll = () => {
  return (
    <div css='font-weight: 500; max-width: 1140px; margin: 20px 0px; '>
      <div css='display: inline-block;'>
        <StyledLink to='/articles'>
          <i className='material-icons' css={`border-radius: 50%; background-color: ${inheritPrimaryColor}; color: white`}>arrow_back</i>
          <div css={`font-size: 1.2em; margin-left: 10px; color: ${inheritPrimaryColor}; ${StyledLink}:hover & { text-decoration: underline }`}>Return to all articles</div>
        </StyledLink>
      </div>
    </div>
  )
}
const Article = styled(({ data, ...props }) => {
  useScrollReset()
  const { articleSlug } = useParams()
  const article = useArticle(null, articleSlug)
  return (
    <div {...props}>
      <div css='max-width: 1140px; flex-grow: 1; display: flex; flex-direction: column; justify-content: center'>
        <ReturnToAll />
        {article
          ? (
            <div css='padding: 35px 0px 75px; font-size: 1.15em; line-height: 1.7em; color: rgb(100, 100, 100); display: flex; justify-content: center;'>
              <div css='max-width: 800px; flex-grow: 1;'>
                <h1 css={`color: ${inheritPrimaryColor}; display: inline-block; font-weight: 400; margin-bottom: 0px;`}>{article.title.rendered}</h1>
                <DateTag>{article.date.replace('T', ' ')}</DateTag>
                <div {...getContentProps(article.acf.content)} />
              </div>
            </div>
          )
          : <div css='align-items: center; margin-top: 30px;' {...props}><Spinner /></div>
        }
      </div>
    </div>
  )
})`
  display: flex;
  padding: 0px 20px;
  justify-content: center;
`
const DateTag = styled.div`
  color: rgb(170, 170, 170);
  font-size: 0.9em;
  margin-bottom: 1.2em;
`
export default Article